import { IForceSyncOrderStatusRule } from '../force-sync-order-status-rule.interface';

export class AbandonedForceSyncRule implements IForceSyncOrderStatusRule {
  showForceSync(): boolean {
    return false;
  }
}
